import { Chip } from '@mui/material';
import { REDESIGN_VERSION_CUTOFF } from './paths';
import { CampaignListRow } from './columns';
import { CampaignTypeTooltip } from './CampaignTypeTooltip';

type CampaignIconProps = {
  row: Pick<CampaignListRow, 'lciVersion' | 'campaignType'>;
};

export const CampaignIcon = (props: CampaignIconProps) => {
  if (props.row.lciVersion < REDESIGN_VERSION_CUTOFF) {
    return null;
  }

  return (
    <Chip
      label={<CampaignTypeTooltip campaignType={props.row.campaignType} />}
      color="primary"
      size="small"
    />
  );
};
